import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { TextBlock, TextBlockRichContent, TextBlockTag } from './ContentBlock.styled';
import { makeHyperlinksReadonly } from '../../../../helpers/UriHelper';
import { hasProgramFeatureAccessPermission } from '../../../../helpers/CommonHelper';

export default function ContentBlock({ title, tags, children }) {
  const {
    meta: { authorized, premium_program_feature_access },
  } = useSelector(state => state.programBrochure);
  const { clientFeatureList } = useSelector(state => state.profile);
  const { clientFeatureList: clientFeatureListOrganization } = useSelector(state => state.auth);
  const { hasPremiumAccess } = hasProgramFeatureAccessPermission(authorized, premium_program_feature_access, clientFeatureList?.premium_program_feature_access || clientFeatureListOrganization?.premium_program_feature_access)

  return (
    <TextBlock>
      {title && <h3 dangerouslySetInnerHTML={{ __html: makeHyperlinksReadonly(title, hasPremiumAccess) }} />}
      {tags.length > 0 &&
        tags.map((tag, index) => (
          <TextBlockTag key={`tag-${index}`} className="text-box__tag">
            {tag}
          </TextBlockTag>
        ))}
      <TextBlockRichContent>{children}</TextBlockRichContent>
    </TextBlock>
  );
}

ContentBlock.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
};

ContentBlock.defaultProps = {
  tags: [],
  title: '',
  children: [],
};
